import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ProgramDropdown } from "CommonDropdowns";
import moment from 'moment-timezone';

const Filter = ({ onFilter, extraFiltersState, setExtraFiltersState }) => {
    // No dropdown, so no show state needed
    const [programValue, setProgramValue] = useState(null);



    const handleSearch = () => {
        onFilter();
    };

    const handleInputChange = (name, value) => {
        setExtraFiltersState({
            ...extraFiltersState,
            values: {
                ...extraFiltersState.values,
                [name]: value,
            },
        });
    };

    const handleDateChange = (date) => {  
        if(!date){
            setExtraFiltersState({
                ...extraFiltersState,
                values: {
                    ...extraFiltersState.values,
                    year: '',
                    month: '',
                    program: [],
                    selectedDate: null,
                    formatDate: ''
                },
            });
        }else{
            let formatDate = moment(date).format('YYYY-MM');
            setExtraFiltersState({
                ...extraFiltersState,
                values: {
                    ...extraFiltersState.values,
                    year: date.getFullYear(),
                    month: date.getMonth() + 1,
                    'formatDate': formatDate,
                    selectedDate: date
                },
            });
        }
        
    };

    const handleProgramChange = (selected) => {
        setProgramValue(selected);
        const programIds = selected ? selected.map(p => p.value) : [];
        handleInputChange("program", programIds);
    };

    // { year, month, program, formatDate } = extraFiltersState.values;
    //const selectedDate = new Date(year, month - 1);

    return (
        <div className="filters-flex">
            <Form>
                <Row className="align-items-end g-3">
                    <Col md={5} sm={12}>
                        <Form.Group className="mb-3">
                            <Form.Label className="label-input">Period</Form.Label>
                            <DatePicker
                                selected={extraFiltersState.values.selectedDate}
                                onChange={handleDateChange}
                                dateFormat="yyyy-MM"
                                showMonthYearPicker
                                className="input-field form-control"
                            />
                        </Form.Group>
                    </Col>
                    <Col md={5} sm={12}>
                        <Form.Group className="mb-3">
                            <ProgramDropdown
                                programValue={programValue}
                                setProgramValue={setProgramValue}
                                isMulti
                                selectedId={extraFiltersState.values.program}
                                programOnChange={handleProgramChange}
                                loadManagerPrograms={true}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={1} sm={12} className="d-flex gap-2 mt-3 mt-md-0">
                        <button
                            type="button"
                            onClick={handleSearch}
                            className="add-new-btn w-100 mb-3"
                        >
                            <img src="/assets/images/search-white.svg" alt="" className="me-2" /> Search
                        </button>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default Filter;
